import React from "react";
import styles from './TermsOfServiceCheckbox.module.scss';
import {linksMap} from 'data/utils/constants';
import FormikCheckBox, {IFormikCheckBoxProps} from "../formikCheckBox/FormikCheckBox";

interface ITermsOfServiceCheckboxProps extends IFormikCheckBoxProps {
}

const TermsOfServiceCheckbox = props => {
  return <FormikCheckBox
    name="acceptedTerms"
    label={<>
      קראתי ואני מאשר/ת תנאי השימוש&nbsp;
      <a
        className={styles.termsLink}
        target="_blank"
        href={linksMap.terms}>
        וההגבלות
      </a>
    </>}
  />;
};

TermsOfServiceCheckbox.defaultProps = {
  loading: false,
};

export default React.memo(TermsOfServiceCheckbox);
